<template>
  <div id="VideoPlayer">
    <div class="videoInfo">
      <template v-if="data_isShowPlayer_b">
        <!-- 播放器 -->
        <div class="video">
          <Aliplayer :data_vid="data_vid" :data_videoInfo="data_videoInfo"></Aliplayer>
        </div>
        <div class="function">
          <span class="views">
            <EyeOutlined />
            {{views}}
          </span>
          <ul class="btns">
            <li @click="data_isCollect_fn">
              <HeartOutlined v-show="!data_isCollect_b"/>
              <HeartFilled v-show="data_isCollect_b"/>
              {{data_isCollect_b?'已收藏':'收藏'}}
            </li>
            <li>
              <ShareAltOutlined />
              分享
              <div class="QRCode">
                <div>分享到微信</div>
                <div id="qrcodeCanvasPlayer"></div>
                <span>微信扫码分享</span>
              </div>
            </li>
          </ul>
        </div>
      </template>

      <template v-else>
        <!-- 播放器封面 -->
        <div
          class="videoPic"
          :style="`background-image:url(${data_videoInfo.cover})`"
        >
          <div class="playBtn" @click="data_payVideo(false)" v-if="data_videoInfo.isTrialCourse === 'T'">
            <PlayCircleFilled />
            免费试看
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  HeartOutlined,
  ShareAltOutlined,
  EyeOutlined,
  PlayCircleFilled,
  HeartFilled,
} from "@ant-design/icons-vue";
import Aliplayer from "@c/course/Aliplayer.vue";
import QRCode from "qrcodejs2";

export default {
  name: "VideoPlayer",
  components: {
    Aliplayer,
    HeartOutlined,
    ShareAltOutlined,
    EyeOutlined,
    PlayCircleFilled,
    HeartFilled,
    QRCode,
  },
  props: ["data_isShowPlayer_b", "data_videoInfo","data_payVideo","data_vid","data_isCollect_fn","data_isCollect_b"],
  data(){
    return {
      views: 0,
      link:'',
      courseId: this.$route.query.courseId?this.$route.query.courseId:this.$route.params.videoId
    }
  },
  methods:{
    // 获取观看人数
    getViews(){
      // 视频浏览量
      // this.data_videoInfo.normalCourseVideos.map((v)=>{
        // if(v.video.vid === this.data_vid){
        //   this.views = v.views;
        // }
      // })
      // 课程浏览量
      this.views = this.data_videoInfo.views
    },
    // 生成二维码
    setQRcode() {
      this.link = window.location.origin + '/ocscourse/#/pages/coursePlay/coursePlay?courseId=' + this.courseId;
      setTimeout(()=>{
        if(!document.querySelector('#qrcodeCanvasPlayer')){
          return;
        }
        document.querySelector('#qrcodeCanvasPlayer').innerHTML = '';
        // 因为可能获取不到页面dom所以延迟
        new QRCode("qrcodeCanvasPlayer", {
          width: 98,
          height: 98, // 高度
          text: this.link, // 二维码内容
          // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          // background: '#f0f',   // 背景色
          // foreground: '#ff0'    // 前景色
        });
      },1000)
    },
  },
  mounted() {
    // 生成二维码 这里和 videoInfo.vue 文件中的二维码结构一样
    this.setQRcode();
  },
  watch:{
    // 课程变化
    "data_videoInfo":{
      handler(n,o){
        this.$nextTick(()=>{
          this.getViews();
        })
      },
      deep:true
    },
    // 每次切换播放器组件判断时触发
    data_isShowPlayer_b(to,from){
      this.setQRcode();
    },
    // 当切换视频vid时重新获取观二维码
    // data_vid:{
    //   handler(n,o){
    //
    //   },
    //   deep:true
    // },
    $route(to,from){
      this.setQRcode();
    }
  },
};
</script>

<style scoped lang="scss">
  #VideoPlayer{
    z-index: 1;
  }
.videoInfo {
  width: 786px;
  /*height: 520px;*/
  border-radius: 6px;
  background: #000;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  .video {
    height:475px;
    border-radius: 6px 6px 0 0;
    overflow: hidden;
  }

  .function {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 45px;
    padding: 0 10px;

    .views {
      color: #fff;

      & > span {
        margin-right: 4px;
      }
    }

    .btns {
      display: flex;

      li {
        font-size: 12px;
        line-height: 26px;
        height: 26px;
        padding: 0 14px;
        background: #818181;
        border-radius: 17px;
        color: #fff;
        cursor: pointer;
        position: relative;
        transition: all 0.3s;

        &:last-of-type {
          margin-left: 20px;
        }

        &:hover {
          background: $theme_blue;
          color: #fff;

          .QRCode {
            visibility: visible;
            opacity: 1;
            transform: translate(-50%, 0);
          }
        }

        .QRCode {
          width: 224px;
          background: #fff;
          border-radius: 6px;
          overflow: hidden;
          position: absolute;
          left: 50%;
          top: 50px;
          box-shadow: 0 0 3px 1px #ddd;
          transform: translate(-50%, 10%);
          display: flex;
          flex-direction: column;
          visibility: hidden;
          opacity: 0;
          transition: all 0.3s;
          transition-delay: 0.3s;
          color: #000;
          z-index: 10;

          div {
            line-height: 38px;
            background: #eff7ff;
            font-size: 14px;
            text-align: center;
          }

          #qrcodeCanvasPlayer {
            width: 98px;
            height: 98px;
            margin: 10px auto;
          }

          span {
            text-align: center;
            font-size: 14px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }

  .videoPic {
    position: relative;
    width: 786px;
    height: 442px;
    border-radius: 6px;
    background-color: #333;
    flex: 0 0 auto;
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .playBtn {
      position: absolute;
      left: 297px;
      bottom: 40px;
      display: flex;
      align-items: center;
      font-size: 24px;
      padding: 0 26px;
      line-height: 56px;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 34px;
      color: #fff;
      cursor: pointer;

      span {
        font-size: 30px;
        margin-right: 12px;
      }
    }
  }
}
</style>
